import React, { useState, useEffect } from 'react';
import './css/ACTRegistration.css';
import { HomeButton } from '../components/website/HomeButton';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';

const ACTRegistration = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false);

    useEffect(() => {
        let errorTimer;

        if (error) {
            errorTimer = setTimeout(() => {
                setError('');
            }, 5000);
        }

        return () => {
            if (errorTimer) {
                clearTimeout(errorTimer);
            }
        }
    }, [error]);

    const handleRegister = async () => {

        setIsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.registerACT, {
                email
            });
            setIsRegistered(true);
            setIsLoading(false);
            console.log(response.data);
        } catch (error) {
            setError(error.response.data.error);
            console.log(error.response.data.error);
            setIsLoading(false);
        }
    }

    return (
        <div>
            <div className="act-registration-container">
                <HomeButton />
                <img src="/img/homepage/charging-infrastructure-homepage.png" alt="charging-infrastructure-homepage" style={{ width: '300px', height: 'auto', margin: '0 auto', paddingTop: '20px' }}></img>
                {isRegistered ? (
                    <div className="act-registration-success">
                        <h1 className="act-registration-success-title">Thank you for registering!</h1>
                        <p className="act-registration-success-text">We will send you an email with instructions to create your account with the free trial.</p>
                        <p className="act-registration-success-text">In the meantime, check out our products <a href="/calculator">here</a>.</p>
                    </div>
                ) : (
                    <div>
                        <div className="act-registration-header">
                            <h1 className="act-registration-header-title">ACT Registration</h1>
                            <p className="act-registration-header-text"> Welcome to AmpTrans! Enter your email below to register for the waitlist for a free trial for our enterprise plan.</p>

                            <p className="act-registration-header-text">
                                We will send you an email with instructions to create your account with the free trial.
                            </p>

                            <p className="act-registration-header-text">
                                This promotion for a 3-month free trial is available until May 8th, 2025.
                            </p>
                            {error && <p className="act-registration-error">{error}</p>}
                        </div>

                        <div className="act-registration-form">
                            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            <button className="btn btn-custom" onClick={handleRegister}>Register</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ACTRegistration;

